module.exports = __webpack_public_path__ + "img/bom6.be751b69.png";